<template>
	<div class="serviceDiv">
		<!-- banner -->
		<div class="banner">
			<img src="../../assets/img/kjBanner7.jpg" alt="">
			<div></div>
		</div>
		<!-- main -->
		<div class="main">
			<!-- 方案咨询 -->
			<div class="consult" id="consult">
				<div class="homeTitle">
					<div class="homeTitleText">方案咨询</div>
					<div class="homeTitleLine"></div>
				</div>
				<!-- 方案二 -->
				<div class="consultCon">
					<div>
						<img src="../../assets/技术服务/369A1C53-8D93-414a-B7A6-212CBE079EB2.png" alt="">
						<div class="consultConText">
							<h3>智慧工地方案咨询</h3>
						</div>
					</div>
					<div>
						<img src="../../assets/技术服务/026157EE-0557-4ea8-8BBB-E00CA5ED8DD7.png" alt="">
						<div class="consultConText">
							<h3>物联网·大数据方案咨询</h3>
						</div>
					</div>
					<div>
						<img src="../../assets/技术服务/050610d1cc182150391ce1e7c552b74f.jpeg" alt="">
						<div class="consultConText">
							<h3>BIM建造方案咨询</h3>
						</div>
					</div>
					<div>
						<img src="../../assets/技术服务/3A16AC2E-9524-44ae-A0DB-D08B765B1E06.png" alt="">
						<div class="consultConText">
							<h3>云应用产品服务方案咨询</h3>
						</div>
					</div>
				</div>
				<div class="homeBtn">
					<a class="more-btn" @click="consultBtn">咨询更多</a>
				</div>
			</div>
			<!-- 定制开发 -->
			<div class="project" id="project">
				<div class="homeTitle">
					<div class="homeTitleText">开发服务</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="projectCon" id="projectCon">
					<!-- for循环开始 -->
					<div>
						<div class="moretop">
							<img src="../../assets/img/project1.png" alt="">
							<p>WEB/h5定制</p>
						</div>
						<div class="morebottom">
							<p>前端主流框架</p>
							<p>驾驶舱开发</p>
							<p>公司建站</p>
							<p>协同平台标准产品模版</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/img/project2.png" alt="">
							<p>小程序定制</p>
						</div>
						<div class="morebottom">
							<p>微信小程序</p>
							<p>支付宝小程序</p>
							<p>百度小程序</p>
							<p>钉钉小程序</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/img/project3.png" alt="">
							<p style="margin-top:10px;">微信公众号定制</p>
						</div>
						<div class="morebottom">
							<p>公众号服务</p>
							<p>服务号</p>
							<p>订阅号</p>
							<p>企业号</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/img/project4.png" alt="">
							<p>APP定制</p>
						</div>
						<div class="morebottom">
							<p>Android应用开发</p>
							<p>lOS应用开发</p>
							<p>建筑工程类APP</p>
							<p>协同办公类APP</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<!-- for循环结束 -->
				</div>
			</div>
			<div class="project" id="project">
				<!-- <div class="homeTitle">
					<div class="homeTitleText">后端开发</div>
					<div class="homeTitleLine"></div>
				</div> -->
				<div class="projectCon">
					<!-- for循环开始 -->
					<div>
						<div class="moretop">
							<img src="../../assets/图片文件夹/prog-java (1).png" alt="">
							<p>Java开发</p>
						</div>
						<div class="morebottom">
							<p>单体应用开发</p>
							<p>微服务开发</p>
							<p>多种数据支持</p>
							<p>接口开发能力</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/图片文件夹/icon-BIMFACE-line.png" alt="">
							<p>BIM图形引擎</p>
						</div>
						<div class="morebottom">
							<p>支持多种模型文件格式</p>
							<p>网页端,移动端模型轻量化展示</p>
							<p>支持在线合模,差异对比等</p>
							<p>支持多样的自定义开发需求</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/图片文件夹/sharpicons_computer-phone.png" alt="">
							<p>硬件接入服务</p>
						</div>
						<div class="morebottom">
							<p>硬件设备接口接入服务</p>
							<p>视频监控</p>
							<p>弱电信号采集</p>
							<p>环境监测数据接入等</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<div>
						<div class="moretop">
							<img src="../../assets/图片文件夹/配置-运维配置.png" alt="">
							<p>运维服务</p>
						</div>
						<div class="morebottom">
							<p>平台运维</p>
							<p>数据日志备份</p>
							<p>功能优化</p>
							<p>用户培训现场指导</p>
							<span @click="consultBtn">点击咨询</span>
						</div>
					</div>
					<!-- for循环结束 -->
				</div>
			</div>
			<!-- BIM建模服务 -->
			<div class="bim" id="bim">
				<div class="homeTitle">
					<div class="homeTitleText">BIM建模</div>
					<div class="homeTitleLine"></div>
				</div>
				<p style="color:black;margin:15px">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BIM的核心是通过建立虚拟的建筑工程三维模型，利用数字化技术，为模型提供完整的、与实际情况一致的建筑工程信息库。借助BIM技术，大大提高了建筑工程的信息集成化程度，从而为建筑工程项目的相关利益方提供了工程信息交换和共享的平台。
				</p>
				<div class="bimCon">
					<!-- for循环开始 -->
					<div class="bimConItem">
						<div class="border_top"></div>
						<div class="border_right"></div>
						<div class="border_bottom"></div>
						<div class="border_left"></div>
						<div class="bimConItemChild">
							<div>
								<img src="../../assets/图片文件夹/revit.png" alt="">
								<h3>
									<span>Autodesk Revit</span>
									<font> 建模软件</font>
								</h3>
							</div>
							<p>
							</p>
						</div>
					</div>
					<div class="bimConItem">
						<div class="border_top"></div>
						<div class="border_right"></div>
						<div class="border_bottom"></div>
						<div class="border_left"></div>
						<div class="bimConItemChild">
							<div>
								<img src="../../assets/图片文件夹/AutoCAD.png" alt="">
								<h3>
									<span>Autodesk Cad</span>
									<font> 图纸查看 编辑软件</font>
								</h3>
							</div>
							<p>

							</p>
						</div>
					</div>
					<div class="bimConItem">
						<div class="border_top"></div>
						<div class="border_right"></div>
						<div class="border_bottom"></div>
						<div class="border_left"></div>
						<div class="bimConItemChild">
							<div>
								<img src="../../assets/图片文件夹/format_Navisworks_24px_outlined.png" alt="">
								<h3>
									<span>Navisworks</span>
									<font>碰撞检测 简易模拟软件</font>
								</h3>
							</div>
							<p>
							</p>
						</div>
					</div>
				</div>
				<div class="bimCon">
					<div class="bimConItem" style="margin-left:17%">
						<div class="border_top"></div>
						<div class="border_right"></div>
						<div class="border_bottom"></div>
						<div class="border_left"></div>
						<div class="bimConItemChild">
							<div>
								<img src="../../assets/图片文件夹/2CC1A3C9-7FC7-42f0-8EA6-DF7BDC8530EC.png" alt="">
								<h3>
									<span>Fuzor</span>
									<font>施工模拟动画软件</font>
								</h3>
							</div>
							<p>
							</p>
						</div>
					</div>
					<div class="bimConItem">
						<div class="border_top"></div>
						<div class="border_right"></div>
						<div class="border_bottom"></div>
						<div class="border_left"></div>
						<div class="bimConItemChild">
							<div>
								<img src="../../assets/图片文件夹/3D Max.png" alt="">
								<h3>
									<span>Autodesk 3D Max</span>
									<font>三维建模渲染和动画制作</font>
								</h3>
							</div>
							<p>
							</p>
						</div>
					</div>
					<!-- for循环结束 -->
				</div>
				<!-- 按钮 -->
				<div class="homeBtn">
					<a class="more-btn" @click="consultBtn">咨询更多</a>
				</div>
			</div>
		</div>
		<!-- 引入咨询弹窗 -->
		<consultPop ref="consultPop"></consultPop>
	</div>
</template>
<script>
	import consultPop from './modules/consultPop.vue'
	export default {
		components: {
			consultPop
		},
		data() {
			return {};
		},
		mounted() {
			// console.log(this.$route.query.pointIdName, "this.$route.query11")
			let pointIdName = this.$route.query.pointIdName
			if (pointIdName != undefined) {
				this.goRule(pointIdName)
			}
		},
		created() {
			document.documentElement.scrollTop = 0;
		},
		methods: {
			//锚点跳转
			goRule(event) {
				let id = "#" + event;
				console.log(document.querySelector(id), "document.querySelector(id)")
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "nearest",
				}, true);
			},
			// 咨询更多
			consultBtn() {
				this.$refs.consultPop.show()
			},
		},
	}
</script>
<style lang="scss" scoped>
	.serviceDiv {
		width: 100%;

		.banner {
			width: 100%;
			height: 450px;
			margin-bottom: 45px;
			position: relative;

			div {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(33, 37, 44, .35);
			}

			img {
				width: 100%;
				height: 100%;
			}
		}

		// 标题开始
		.homeTitle {
			width: 100%;
			text-align: center;
			margin: 0 auto;
			margin-bottom: 35px;

			.homeTitleText {
				height: 45px;
				font-size: 31px;
				color: #000;
				font-weight: 500;
				// padding: 60px 0 8px 0;
				padding: 30px 0 8px 0;
			}

			.homeTitleLine {
				width: 64px;
				height: 3px;
				background: #006fff;
				margin: 0 auto;
			}
		}

		// 标题结束
		// homeBtn开始**********************
		.homeBtn {
			width: 100%;
			text-align: center;
			// margin: 48px 0 65px 0;
			margin: 48px 0 80px 0;
		}

		.more-btn {
			text-decoration: none;
			position: relative;
			display: inline-block;
			padding: 10px 35px;
			font-size: 14px;
			color: #fff;
			background-color: #409EFF;
			border-radius: 20px;
			cursor: pointer;
			margin-bottom: 20px;
		}

		.more-btn::before {
			position: absolute;
			content: '';
			width: 100%;
			height: 100%;
			border: 1.5px solid #409EFF;
			top: 50%;
			left: 50%;
			padding: 5px;
			transform: translate(-50%, -50%);
			border-radius: inherit;
			border-radius: 30px;
			-webkit-animation: actif-btn-wave 1s infinite ease-out;
			animation: actif-btn-wave 1s infinite ease-out;
		}

		.more-btn:hover {
			-webkit-animation: anim-moema-1 0.4s forwards;
			animation: anim-moema-1 0.4s forwards;
		}

		@keyframes actif-btn-wave {
			0% {
				-webkit-transform: translate(-50%, -50%) scale(1);
				transform: translate(-50%, -50%) scale(1);
				opacity: 1;
				-webkit-transform-origin: center;
				transform-origin: center;
			}

			100% {
				-webkit-transform: translate(-50%, -50%) scale(1.2);
				transform: translate(-50%, -50%) scale(1.2);
				opacity: 0;
				-webkit-transform-origin: center;
				transform-origin: center;
			}
		}

		@keyframes anim-moema-1 {
			60% {
				-webkit-transform: scale3d(0.8, 0.8, 1);
				transform: scale3d(0.8, 0.8, 1);
			}

			85% {
				-webkit-transform: scale3d(1.1, 1.1, 1);
				transform: scale3d(1.1, 1.1, 1);
			}

			100% {
				-webkit-transform: scale3d(1, 1, 1);
				transform: scale3d(1, 1, 1);
			}
		}

		// homeBtn结束**********************
		.project,
		.consult,
		.bim {
			width: 70%;
			margin: 0 auto;
			margin-bottom: 40px;
			position: relative;
		}

		// 方案咨询开始************* 
		.consult {
			.consultCon {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				margin-top: 20px;

				div {
					width: 48%;
					height: 260px;
					position: relative;
					margin-bottom: 10px;
					overflow: hidden;
					margin-left: 10px;

					img {
						width: 100%;
						height: 100%;
						transition: all 0.3s ease-out;
					}

					.consultConText {
						position: absolute;
						width: 100%;
						color: white;
						z-index: 9;
						left: 4%;
						top: 60%;

						h3 {
							font-size: 28px;
							margin-top: 55px;
						}
					} 
				}
			}
		}

		.consultCon>div:nth-child(2n-1) {
			margin-right: 2%;
		}

		.consultCon>div:hover img {
			transform: scale(1.1);
		}

		// 方案咨询结束************* 

		// 定制开发开始*************
		.project {
			.projectCon {
				display: flex;
				flex-direction: row;
			}
		}

		.projectCon>div {
			width: 24%;
			margin: 0 0.5%;
			text-align: center;
			box-shadow: 0px 2px 2.5px 0px rgba(0, 0, 0, 0.08);

			span {
				// display: inline-block;
				// width: 120px;
				// height: 40px;
				// background: linear-gradient(to top, #409EFF, #409EFF);
				// border-radius: 10px;
				// text-align: center;
				// line-height: 40px;
				// color: #fff;
				margin-top: 30px;
				cursor: pointer;
				text-decoration: none;
				position: relative;
				display: inline-block;
				padding: 10px 35px;
				font-size: 14px;
				color: #fff;
				background-color: #409EFF;
				border-radius: 20px;
			}
		}

		// .projectCon>div span::before {
		// 	position: absolute;
		// 	content: '';
		// 	width: 100%;
		// 	height: 100%;
		// 	border: 1.5px solid #409EFF;
		// 	top: 50%;
		// 	left: 50%;
		// 	padding: 5px;
		// 	transform: translate(-50%, -50%);
		// 	border-radius: inherit;
		// 	border-radius: 30px;
		// 	-webkit-animation: actif-btn-wave 1s infinite ease-out;
		// 	animation: actif-btn-wave 1s infinite ease-out;
		// }

		// .projectCon>div span:hover {
		// 	-webkit-animation: anim-moema-1 0.4s forwards;
		// 	animation: anim-moema-1 0.4s forwards;
		// }

		// @keyframes actif-btn-wave {
		// 	0% {
		// 		-webkit-transform: translate(-50%, -50%) scale(1);
		// 		transform: translate(-50%, -50%) scale(1);
		// 		opacity: 1;
		// 		-webkit-transform-origin: center;
		// 		transform-origin: center;
		// 	}

		// 	100% {
		// 		-webkit-transform: translate(-50%, -50%) scale(1.2);
		// 		transform: translate(-50%, -50%) scale(1.2);
		// 		opacity: 0;
		// 		-webkit-transform-origin: center;
		// 		transform-origin: center;
		// 	}
		// }

		// @keyframes anim-moema-1 {
		// 	60% {
		// 		-webkit-transform: scale3d(0.8, 0.8, 1);
		// 		transform: scale3d(0.8, 0.8, 1);
		// 	}

		// 	85% {
		// 		-webkit-transform: scale3d(1.1, 1.1, 1);
		// 		transform: scale3d(1.1, 1.1, 1);
		// 	}

		// 	100% {
		// 		-webkit-transform: scale3d(1, 1, 1);
		// 		transform: scale3d(1, 1, 1);
		// 	}
		// }

		.projectCon>div:nth-child(1) {
			margin-left: 1%;
		}

		.projectCon>div:nth-child(4) {
			margin-right: 1%;
		}

		.moretop {
			height: 140px;
			border-radius: 10px 10px 0px 0px;
			color: #fff;

			img {
				width: 50px;
				margin: 28px 0 20px;
			}
		}

		.morebottom {
			height: 300px;
			background: #fff;
			border-radius: 0px 0px 10px 10px;

			p {
				color: #999;
				padding-top: 30px;
			}
		}

		.projectCon>div:nth-child(1) .moretop {
			background: linear-gradient(113deg, #B08CFE 0%, #687BF7 100%);
		}

		.projectCon>div:nth-child(2) .moretop {
			background: linear-gradient(to left, #FE6D03, #FFBD7A);
		}

		.projectCon>div:nth-child(3) .moretop {
			background: linear-gradient(to left, #FF534F, #FF9876);
		}

		.projectCon>div:nth-child(4) .moretop {
			background: linear-gradient(113deg, #7BECBA 0%, #18CDBA 100%);
		}

		// 定制开发结束************* 
		// BIM建模服务开始*************
		.bim {
			.homeBtn {
				margin: 28px 0 60px 0;
			}

			.bimCon {
				/* display: flex;
				flex-direction: row;
				flex-wrap: wrap; */
				display: flex;

				/* flex-direction: row;
				flex-wrap: wrap; */
				.bimConItem {
					width: 32%;
					margin-bottom: 20px;
					position: relative;
					border: 1px #e2e2e2 solid;
					border-radius: 8px;
					overflow: hidden;

					.bimConItemChild {
						height: 180px;
						padding: 20px;

						div {
							width: 100%;
							margin: 20px auto 0;
							display: flex;
							justify-content: center;
							align-items: center;
							/* flex-direction: row; */
							margin-top: 50px;

							img {
								width: 100px;
								height: 100px;
							}

							h3 {
								padding: 0;
								font-weight: normal;
								margin-left: 15px;

								span {
									font-size: 20px;
									line-height: 34px;
									display: block;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}

								font {
									font-size: 18px;
									color: #333;
									line-height: 22px;
									padding-top: 6px;
									display: block;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}
						}

						p {
							width: 100%;
							margin: 0 auto;
							padding-top: 9px;
							font-size: 12px;
							color: #666;
							line-height: 22px;
							padding-bottom: 16px;
						}
					}
				}
			}
		}

		.bimCon>.bimConItem:nth-child(3n-1) {
			margin: 0 1.74%;
			margin-bottom: 20px;
		}

		.bimConItem .border_top,
		.bimConItem .border_right,
		.bimConItem .border_bottom,
		.bimConItem .border_left {
			-webkit-transition: all .4s ease;
			-moz-transition: all .4s ease;
			-ms-transition: all .4s ease;
			transition: all .4s ease;
		}

		.bimConItem .border_top,
		.bimConItem .border_left {
			left: 0;
			top: 0;
			position: absolute;
			background: #5CB5F4;
		}

		.bimConItem .border_right,
		// .newsInfoConStar .border_bottom{bottom:0;right:0; position:absolute; background:#207be6;}
		.bimConItem .border_bottom {
			bottom: 0;
			right: 0;
			position: absolute;
			background: #5CB5F4;
		}

		.bimConItem .border_top,
		.bimConItem .border_bottom {
			height: 1px;
			width: 0;
		}

		.bimConItem .border_right,
		.bimConItem .border_left {
			height: 0px;
			width: 1px;
		}

		// .newsInfoConStar .download-detail:hover{border-color: transparent;}
		.bimConItem:hover .border_top,
		.bimConItem:hover .border_bottom {
			width: 100%
		}

		.bimConItem:hover .border_left,
		.bimConItem:hover .border_right {
			height: 100%
		}

		// newsInfo结束**********************
		// BIM建模服务结束************* 

	}
</style>